import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'

import s from '../styles.module.scss'

interface BaggageInfoProps {
  hasBaggage: boolean
  hasHandBaggage: boolean
  baggageWeight?: string
  handBaggageWeight?: string
}

export const BaggageInfo = ({
  hasBaggage,
  hasHandBaggage,
  baggageWeight,
  handBaggageWeight,
}: BaggageInfoProps) => {
  const { t } = useTranslation()
  return (
    <div className={s.baggageInfo}>
      <span className={s.baggageTag}>
        <AppIcon
          id={hasBaggage ? AllIcons.BAGGAGE : AllIcons.BAGGAGE_DISABLED}
          width={16}
          height={16}
          className={clsx(s.baggageIcon, !hasBaggage && s.disabled)}
        />
        <span className={clsx('medium-12', s.baggageText)}>
          {hasBaggage ? baggageWeight : t('without_baggage')}
        </span>
      </span>
      <span className={s.baggageTag}>
        <AppIcon
          id={hasHandBaggage ? AllIcons.CBAGGAGE : AllIcons.CBAGGAGE_DISABLED}
          width={16}
          height={16}
          className={clsx(s.baggageIcon, !hasBaggage && s.disabled)}
        />
        <span className={clsx('medium-12', s.baggageText)}>
          {hasHandBaggage ? handBaggageWeight : t('without_cbaggage')}
        </span>
      </span>
    </div>
  )
}
